/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
//img
import GuestModeImg from '@assets/images/bg/guest-mode-popup.png'
// css
import { GuestModePopupWrap } from './index.style'

const GuestModePopup: React.FC = () => {

  return (
    <GuestModePopupWrap>
      <img src={GuestModeImg} alt="" width='191px' height='auto'/>
    </GuestModePopupWrap>
  )
}

export default observer(GuestModePopup)
